import type { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { scopeAccessorials } from "@/Data/scopeAccessorials";

export function getAccessorials(
  scope: LocationContext | undefined,
  locationType: LocationType | undefined,
  typePrefix?: string,
) {
  const afterScope = scopeAccessorials(scope, locationType);

  if (typePrefix) {
    return afterScope.filter((item) => item.type?.startsWith(typePrefix));
  } else {
    return afterScope;
  }
}
